/**
 * API-Basis zur Laufzeit. Eigene Datei, damit Status-Polling nicht im Kreis
 * über den apiClient importieren muss.
 */
export const API_BASE: string = (() => {
  if (typeof window === "undefined") return "";
  const fromMeta = document
    .querySelector('meta[name="eh-api-base"]')
    ?.getAttribute("content");
  if (fromMeta) return fromMeta.replace(/\/$/, "");
  const host = window.location.hostname;
  if (host === "dev.app.ernsthaus.de" || host === "www.dev.app.ernsthaus.de") {
    return "https://dev.api.ernsthaus.de";
  }
  if (host === "app.ernsthaus.de" || host === "www.app.ernsthaus.de") {
    return "https://api.ernsthaus.de";
  }
  return "";
})();
